import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MaterialIcon, MaterialSymbolsFont } from '../_shared/materialSymbols.js';
export const trustBlockSchema = {
    type: 'trust',
    name: 'Trust chip',
    max: 6,
    fields: [
        {
            id: 'icon',
            type: 'icon-name',
            label: 'Icon',
            default: 'verified_user',
            placeholder: 'check_circle',
            info: 'Type a Google Material Symbols name (e.g. verified_user, local_shipping, payments). Search names on fonts.google.com/icons. Upload a custom image below to override.',
        },
        {
            id: 'filledIcon',
            type: 'checkbox',
            label: 'Filled icon',
            default: false,
            info: 'Renders the solid (filled) variant of the icon.',
        },
        { id: 'image', type: 'image', label: 'Custom icon image' },
        { id: 'text', type: 'text', label: 'Text', default: 'Garantie', maxLength: 60 },
    ],
};
/**
 * A reassurance line: accent icon + text (e.g. "Paiement à la livraison"). The icon is a Google Material
 * Symbols glyph (the merchant types a NAME, e.g. `verified_user`; a custom image overrides it). Legacy
 * curated ids (`shield-check`…) still render via the back-compat map. {@link MaterialSymbolsFont} loads
 * the webfont (page-subset on the storefront, full font in the builder).
 */
const TrustBlock = ({ block }) => {
    const bs = block.settings;
    return (_jsxs("div", { style: {
            display: 'flex',
            alignItems: 'center',
            gap: 'var(--aqx-theme-space-2, 8px)',
            fontSize: 'var(--aqx-theme-text-sm, 14px)',
            color: 'var(--aqx-scheme-muted)',
        }, children: [_jsx(MaterialSymbolsFont, {}), _jsx("span", { style: { color: 'var(--aqx-scheme-accent)', display: 'inline-flex' }, "aria-hidden": "true", children: _jsx(MaterialIcon, { name: bs.icon ?? 'verified_user', filled: bs.filledIcon === true, image: bs.image, size: 18 }) }), _jsx("span", { children: bs.text ?? '' })] }));
};
export const trustBlock = {
    type: 'trust',
    schema: trustBlockSchema,
    Component: TrustBlock,
    meta: { label: 'Trust chip' },
};
//# sourceMappingURL=index.js.map